<template>
<div class="row">
  <div class="col-md-12">
    <div class="card vx-card">
      <div class="card-body" v-loading="loading">
        <div class="d-flex justify-content-between align-items-center">
          <div>
            <!-- <h4 class="font-weight-bold">Lista de artículos</h4> -->
            <registers-per-page @changeNumPerPage="changeNumPerPage"></registers-per-page>
            <search-filter @executeSearch="search" :options="[]"></search-filter>
          </div>
          <vs-button type="gradient" @click="newItem()">
            <i class="fa fa-plus"></i>
            Nueva familia
          </vs-button>
        </div>

        <div id="data-list-list-view" class="data-list-container mt-5" v-if="items.length">
            <vs-table ref="table" :max-items="perPage" :data="items">
              <template slot="thead">
                <vs-th>Nombre</vs-th>
                <vs-th>Acciones</vs-th>
              </template>

              <template slot-scope="{ data }">
                <tbody>
                  <vs-tr :data="item" :key="indextr" v-for="(item, indextr) in data">
                    <vs-td>
                      {{ item.name }}
                    </vs-td>
                    <vs-td class="whitespace-no-wrap">
                      <el-dropdown @command="itemAction">
                        <i class="fa fa-cogs text-primary"></i>
                        <el-dropdown-menu slot="dropdown">
                          <el-dropdown-item :command="{ action: 'edit', id: item.id }" class="text-success">
                            <i class="fa fa-edit"></i>
                            Editar
                          </el-dropdown-item>
                          <el-dropdown-item :command="{ action: 'delete', payload: { id: item.id } }" class="text-danger">
                            <i class="fa fa-times"></i>
                            Eliminar
                          </el-dropdown-item>
                        </el-dropdown-menu>
                      </el-dropdown>
                    </vs-td>
                  </vs-tr>
                </tbody>
              </template>
            </vs-table>

            <div class="mt-4 text-center zatura-pagination" v-if="pageCount > 1">
              <vs-pagination :total="pageCount" v-model="page"></vs-pagination>
            </div>
          </div>

          <div class="col-md-12 text-center" v-if="!loading && items.length == 0">
            <p>No hay familias.</p>
          </div>
      </div>
    </div>
  </div>

  <!-- modal new item -->
    <vs-popup title="Nueva familia" :active.sync="newItemModal">
      <div class="col-md-12" v-loading="loading" element-loading-text="Guardando por favor espere">
        <form @submit.prevent="storeItem()">
          <div class="row">
            <div class="card vx-card">
              <div class="card-header bg-white">
                <h4 class="">Información Familia</h4>
              </div>

              <div class="card-body">
                <div class="row">
                  <div class="col-md-12">
                    <text-input
                      name="name"
                      :label="'Nombre'"
                      v-validate="'required'"
                      :error="errors.first('name')"
                      v-model="item.name"
                      data-vv-as="Nombre">
                    </text-input>
                  </div>

                  <div class="col-md-12 text-center p-t-20">
                    <vs-button button="submit" color="primary" type="filled">
                      <i class="fa fa-save"></i>
                      Guardar
                    </vs-button>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </form>
      </div>
    </vs-popup>
    <!-- end modal new item -->

    <!-- modal edit item -->
    <vs-popup :active.sync="editItemModal" title="Editar familia">
      <div class="col-md-12" v-loading="loading" element-loading-text="Guardando por favor espere">
        <form @submit.prevent="updateItem()">
          <div class="row">
            <div class="card vx-card">
              <div class="card-header bg-white">
                <h4 class="">Información Familia</h4>
              </div>

              <div class="card-body">
                <div class="row">
                  <div class="col-md-12">
                    <text-input
                      name="name"
                      :label="'Nombre'"
                      v-validate="'required'"
                      :error="errors.first('name')"
                      v-model="item.name"
                      data-vv-as="Nombre">
                    </text-input>
                  </div>

                  <div class="col-md-12 text-center p-t-20">
                    <vs-button button="submit" color="primary" type="filled">
                      <i class="fa fa-save"></i>
                      Guardar
                    </vs-button>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </form>
      </div>
    </vs-popup>
    <!-- end modal edit item -->
</div>
</template>

<script>
import familiesService from '@/services/families.service.js';
import SearchFilter from '@/components/SearchFilter.vue';
import RegistersPerPage from '@/components/RegistersPerPage';
import Modal from '@/components/Modal.vue';

export default {
  name: 'items',
  data() {
    return {
      items: [],
      loading: true,
      pageCount : 1,
      perPage: 10,
      page: 1,
      searchData: {},
      item: {
        name: ""
      },
      newItemModal: false,
      editItemModal: false,
    }
  },
  methods: {
    changeNumPerPage(num) {
      let searchData = this.searchData;
      searchData.perPage = num
      this.searchData = searchData
      this.getFamilies(1, this.searchData)
    },
    search(search) {
      this.searchData = search;
      this.searchData.perPage = this.perPage
      this.getFamilies(1, this.searchData)
    },
    getFamilies(page = 1, search = {}) {
      familiesService.getFamilies(page, search).then(res => {
        this.items = res.data.data
        this.loading = false;
        this.pageCount = res.data.last_page;
      }).catch(error => {
        this.loading = false;
        if(error.response.status == 401) {
          // localStorage.clear();
          // this.$router.push('login');
        }
      })
    },
    resetForm() {
      let data_form_initial = this.$options.data().item;
      Object.assign(this.$data.item, data_form_initial);
      this.$validator.reset();
    },
    newItem() {
      this.resetForm();
      this.newItemModal = true;
    },
    itemAction(command) {
      if(command.action == 'edit') {
        //this.$router.push({name: 'edit-item', params: {id: command.id} });
        this.resetForm();
        this.getFamily(command.id);
        this.editItemModal = true;
      } else if(command.action == 'delete') {
         this.$confirm('¿ Deseas eliminar la familia ?', 'Eliminar Familia', {
            confirmButtonText: 'Si, continuar',
            cancelButtonText: 'Cancelar',
            type: 'warning',
            center: true
          }).then(() => {
            this.loading = true;
            let index = this.items.findIndex(i => i.id === command.payload.id);
            familiesService.deleteFamily(command.payload.id)
            .then(() => {
              this.loading = false;
              this.items.splice(index, 1);
              this.$message({
                type: 'success',
                message: 'Familia eliminada'
              });
            })
            .catch(() => {
              this.loading = false;
              this.$message({
                type: 'error',
                message: 'Ocurrio un problema'
              });
            });
          }).catch(() => {
            this.loading = false;
            this.$message({
              type: 'info',
              message: 'Acción cancelada'
            });
          });
      }
    },
    goPage(numPage) {
      this.getFamilies(numPage, this.searchData);
    },
    storeItem() {
      this.$validator.validate().then(valid => {
        if (valid) {
          let data = this.item;
          this.loading = true;
          familiesService.storeFamily(data)
          .then(() => {
            this.loading = false;
            this.$message({
              showClose: true,
              message: 'Familia guardada correctamente',
              type: 'success',
              duration: 1500
            });
            this.getFamilies(1, this.searchData);
            this.newItemModal = false;
          })
          .catch(function (error) {
            this.loading = false;
            this.$message({
              showClose: true,
              message: error.response.data.message,
              type: 'error'
            });
          });
        }
      });
    },
    getFamily(id) {
      familiesService.getFamily(id)
      .then((res) => {
        this.item = res.data.item;
      })
      .catch((error) => {
        this.$message({
          showClose: true,
          message: error.response.data.message,
          type: 'error'
        });
      });
    },
    updateItem() {
      this.$validator.validate().then(valid => {
        if (valid) {
          this.loading = true;
          let data = this.item;
          familiesService.updateFamily(data)
          .then(() => {
            this.loading = false;
            this.$message({
              showClose: true,
              message: 'Familia actualizada correctamente',
              type: 'success',
              duration: 1500
            });
            this.getFamilies(1, this.searchData);
            this.editItemModal = false;
          })
          .catch((error) => {
            this.loading = false;
            this.$message({
              showClose: true,
              message: error.message,
              type: 'error',
              duration: 1500
            });
          });
        }
      });
    }
  },
  watch: {
    page(newVal) {
      this.goPage(newVal);
    }
  },
  created() {
    this.getFamilies();
  },
  components: {
    SearchFilter,
    RegistersPerPage,
    Modal
  }
};
</script>

<style scope>

.box-shadow {
  box-shadow: 0 0 2px rgb(136, 124, 124) !important;
}

.oculto {
  display: none;
}

.con-vs-popup .vs-popup {
  width: 700px !important;
}

.el-select-dropdown__item {
  max-width: 600px;
  position: static;
  white-space: break-spaces;
  text-overflow: none;
  /* height: auto !important; */
  height: auto;
  max-height: 60px;
}
</style>
